<template>
  <div class="container mt-20 align-top mx-auto">
  <div class="flex mb-4">
  <div class="w-1/3"></div>
  <div class="max-w-sm bg-white rounded overflow-hidden shadow-lg">
  <img class="w-full" src="../assets/me.jpg" alt="Oops...">
  <div class="px-6 py-4">
  <div class="font-bold text-xl mb-2 text-center">Akshay KH</div>
    <p class="text-grey-darker text-base text-center">
      Web developer since 2015 currently working at Kemuri Techonology as Senior System Engineer.
Fan of <a href="https://laravel.com">Laravel</a> & <a href="https://vuejs.org">Vue</a>
    </p>
</div>
<div class="px-6 py-4">
  <div class="flex justify-center">
    <a class="twitterBtn smGlobalBtn mr-6" target="_blank" href="//twitter.com/iamakshaykh" ></a>
    <a class="linkedinBtn smGlobalBtn mr-6" target="_blank" href="//www.linkedin.com/in/akshay-kh" ></a>
    <a class="EmailBtn smGlobalBtn" target="_blank" href="mailto:ugetakshaykh@gmail.com" ></a>
  </div>
</div>
</div>
  <div class="w-1/3"></div>
</div>
  </div>
</template>

<script>
export default {
  name: 'MainContainer',
  props: {
    msg: String
  }
}
</script>


<style scoped>
@import url('//maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css');

#social {
  margin: 20px 10px;
  text-align: center;
}

.smGlobalBtn { /* global button class */
    display: inline-block;
    position: relative;
    cursor: pointer;
    width: 50px;
    height: 50px;
    border:2px solid #ddd; /* add border to the buttons */
    box-shadow: 0 3px 3px #999;
    padding: 0px;
    text-decoration: none;
    text-align: center;
    color: #fff;
    font-size: 25px;
    font-weight: normal;
    line-height: 2em;
    border-radius: 27px;
    -moz-border-radius:27px;
    -webkit-border-radius:27px;
}
/* linkedin button class*/
.linkedinBtn{
    background: #0094BC;
}

.linkedinBtn:before{
      font-family: "FontAwesome";
      content: "\f0e1"; /* add linkedin icon */
}

.linkedinBtn:hover{
      color: #0094BC;
      background: #fff;
      border-color: #0094BC;
}
/* twitter button class*/
.twitterBtn{
    background: #00ABE3;
}

.twitterBtn:before{
      font-family: "FontAwesome";
      content: "\f099"; /* add twitter icon */

}

.twitterBtn:hover{
      color: #00ABE3;
      background: #fff;
      border-color: #00ABE3;
}

/* linkedin button class*/
.EmailBtn{
    background: #bd0040;
}

.EmailBtn:before{
      font-family: "FontAwesome";
      content: "\f1d8"; /* add linkedin icon */
}

.EmailBtn:hover{
      color: #bd0040;
      background: #fff;
      border-color: #bd0040;
}
</style>
